/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * An ICD-10 code billed for a visit. ACCESS asks only for the code.
 */
export interface Icd10Coding {
  /** The ICD-10 code */
  code: string;
  /** The display term for the ICD-10 code */
  display?: string | null;
}
